import React, { useEffect, useState } from "react";
import { Button } from "../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import {
  GridAlignment,
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel
} from "@mui/x-data-grid-pro";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import { TableHeaderProps } from "../../../../../utils/types";
import { ColumnVisibilityFor } from "../../../../../utils/Enum.Datagrid";
import Input from "../../../../../stories/Input/Input";
import {
  labelClasses,
  LabeledAutocomplete
} from "../../../../../styles/AutocompleteStyles";
import { Keys } from "../../../../../utils/Enum.keys";
import { handleMUISelectEvent } from "../../../../../utils/UtilFunctions";
import { TextField } from "@mui/material";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../../styles/Variables";
import NoData from "../../../../../images/NoData.svg";
import { Title } from "../../../../../stories/Title/Title";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import Navbar from "../../../../common/layout/Navbar";
import { LicenseTypes } from "../../../../../utils/Enum.types";
const Data = [
  {
    code: "Code1",
    description: "CCTV Camera",
    group: "Camera",
    category: "equipment",
    sub_catg: "Laptop",
    ref_no: "Acer-220",
    uom: "No's",
    ob: "-"
  }
];
const groupOptions = ["IT Equipment", "Tools and Machinery", "Softwares"];

const StockBalanceList = () => {
  const navigate = useNavigate();
  const { Purchase } = useAssetTableJson();
  const {customer_id}=useUrlParams();

  const dynamicHeaders: TableHeaderProps[] = Purchase.stockBalance.List.map(
    (header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      cellClassName: header.cellClassName
    })
  );
  const columns: GridColDef[] = [...dynamicHeaders];

  const rows1: GridValidRowModel[] =
    (Data || []).map((data, index) => {
      return {
        id: index + 1,
        code: data.code,
        description: data.description,
        uom: data.uom,
        group: data.group,
        category: data.category,
        manufacturer: data.uom,
        stock_services: "stock",
        hsn: 1,
        gst_percentage: 5,
        locations: 3,
        main_store: 0,
        sub_store: 0,
        stock_in_hand: 0,
        total: 0
      };
    }) || [];

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(ColumnVisibilityFor.STOCK_BALANCE);
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.STOCK_BALANCE,
      JSON.stringify(newModel)
    );
  };
  return (
    <>
      <Navbar NavType={LicenseTypes.SUBSIDIARY} />
      <Title>Stock Balance</Title>
      <div className="stock-balance">
        <div className="stock-balance__select row g-0">
          <div className="col">
            <Input id="data_search" placeholder="Search..." />
          </div>
          <div className="col-2">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              options={groupOptions}
              openOnFocus
              forcePopupIcon
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="Group"
                  slotProps={{
                    inputLabel: {
                      shrink: true
                    }
                  }}
                />
              )}
            />
          </div>
          <div className="col-2">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              options={groupOptions}
              openOnFocus
              forcePopupIcon
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="Category"
                  slotProps={{
                    inputLabel: {
                      shrink: true
                    }
                  }}
                />
              )}
            />
          </div>
          <div className="col-2">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              options={groupOptions}
              openOnFocus
              forcePopupIcon
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="Sub-Category"
                  slotProps={{
                    inputLabel: {
                      shrink: true
                    }
                  }}
                />
              )}
            />
          </div>
          <div className="col-2">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              options={groupOptions}
              openOnFocus
              forcePopupIcon
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="Manufacturer"
                  slotProps={{
                    inputLabel: {
                      shrink: true
                    }
                  }}
                />
              )}
            />
          </div>
          <div className="col-2">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              options={groupOptions}
              openOnFocus
              forcePopupIcon
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="HSN"
                  slotProps={{
                    inputLabel: {
                      shrink: true
                    }
                  }}
                />
              )}
            />
          </div>
        </div>
        <div className="stock-balance__tableblock">
          {Data.length ? (
            <StyledDatagrid
              columns={columns}
              rows={rows1}
              rowHeight={TABLE_ROW_HEIGHT}
              columnVisibilityModel={columnVisibilityModel}
                onCellClick={(params) => {
                  if (params.field === "code") {
                   navigate(`/assets/purchase/${customer_id}/stockbalance/add`);
                  }
                }}
              onColumnVisibilityModelChange={handleColumnVisibilityChange}
              initialState={{
                columns: {
                  columnVisibilityModel: columnVisibilityModel
                }
              }}
              disableRowSelectionOnClick
              hideFooter
            />
          ) : (
            <>
              <img src={NoData} alt="" className="nodata-image" />
            </>
          )}
        </div>
        <Button mode="back" onClick={() => navigate(-1)} />
      </div>
    
    </>
  );
};

export default StockBalanceList;
